import React, { useRef } from 'react';
import { Icon } from 'antd'
import './index.less'

const arr = [2, 22, 355];

export default (props) => {
  const { data, index, getTagInfo, showDrawer, collId, setCheckModalVisible, setCollId } = props;

  return (
    <div className={`${"threeColumnsItem"}  ${index % 6 == 0 ? "collFirst" : ''}  ${index < 6 ? "rowFirst" : ''}`} onClick={() => {
      getTagInfo(data?.collId)
      showDrawer()
    }}>
      {
        collId == data.collId ? <div className='choose_mask'><Icon style={{ fontSize: 48, color: '#fff', marginTop: 56 }} type="check" /></div> : null
      }

      <div className="threeColumnsItemImgs">
        {data?.covers?.slice(0, 3).map((v, i) => (
          <img
            key={i}
            data-contextmenu={true}
            data-collid={data.collId}
            className={'threeColumnsItemImgs_' + (i + 1)}
            src={v + `${i == 0 ? '?x-oss-process=image/auto-orient,1/resize,m_fill,w_161,h_161,limit_0' : '?x-oss-process=image/auto-orient,1/resize,m_fill,w_82,h_80,limit_0'}`}
          />
        ))}
        <div className="mask1"></div><div className="mask2"></div><div className="mask3">
          <>
            <div className="trueCount"></div>
            <span>{data?.count}</span>
          </>
        </div>
      </div>
      <div style={{ display: 'flex' }}>
        <span className="secondLine">
          {data?.collName}
        </span>
        <span className='coll_detail' onClick={e => {
          e.stopPropagation()
          setCollId(data.collId)
          setCheckModalVisible(true)
        }}  >→详情</span>
      </div>
    </div>
  );
};
